import type { Theme } from "@mui/material/styles";

export const getModalEditionChangeStyles = (theme: Theme, isEnrolled?: boolean, isDisabled?: boolean) => ({
  "editionCard": {
    cardBox: {
      backgroundColor: theme.customColors.backgroundCard,
      borderRadius: "8px",
      mb: 1,
      overflow: "hidden",
      padding: "1rem 0rem",
      minHeight: "fit-content",
      border: `1px solid ${theme.customColors.border}`,
      "&:hover": {
        borderColor: !isDisabled && !isEnrolled && theme.customColors.borderAccent
      },
      ...(isEnrolled && {
        border: `1px solid ${theme.customColors.borderSecondaryComplete}`
      })
    },
    cardAccordion: {
      backgroundColor: "transparent",
      boxShadow: "none",
      "&:before": { display: "none" }
    },
    cardRadio: {
      "&:hover": { backgroundColor: "transparent" },
      "&.Mui-checked": { color: theme.customColors.textPrimary },
      "&.Mui-disabled": { color: theme.customColors.textPrimary, opacity: 1 },
      color: theme.customColors.textPrimary
    } 
  },
  "editionHeader": {
    text: { 
      color: theme.customColors.exploreCardText,
      fontSize: "0.75rem",
      lineHeight: "1.5rem",
      opacity: 0.7
    }
  },
  "modalEditionChange": {
    modal: {
      zIndex: 1400
    },
  
    modalBox: {
      backgroundColor: theme.customColors.backgroundPrimaryLighter,
      border: `2px solid ${theme.customColors.border}`,
      borderRadius: "16px",
      boxShadow: 24,
      display: "flex",
      flexDirection: "column" as const,
      justifyContent: "space-between",
      left: "50%",
      maxHeight: "90vh",
      maxWidth: "900px",
      overflow: "auto",
      position: "absolute" as const,
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: { lg: "60%", md: "70%", sm: "80%", xs: "100vw" }
    },

    headerBox: {
      alignItems: "center",
      backgroundColor: theme.customColors.backgroundPrimaryLighter,
      display: "flex",
      justifyContent: "space-between",
      p: "1.5rem",
      position: "sticky" as const,
      top: 0,
      zIndex: 2
    },

    headerTitle: {
      fontWeight: 700
    },

    contentBox: {
      px: "1.5rem"
    },

    footerBox: {
      backgroundColor: theme.customColors.backgroundPrimaryLighter,
      display: "flex",
      justifyContent: "flex-end",
      mr: 1,
      p: "1rem"
    },

    cancelButton: {
      "&.MuiButton-outlinedPrimary": {
        "&:hover": {
          borderColor: theme.customColors.borderPrimaryCta
        },
        borderColor: theme.customColors.textPrimary
      },
      color: theme.customColors.textPrimary,
      marginRight: 1
    },

    enrollButton: {
      "&:not(.Mui-disabled)": {
        "&:hover": {
          backgroundColor: theme.customColors.accentVariantA,
          filter: "brightness(0.85)"
        },
        backgroundColor: theme.customColors.accentVariantA
      }
    }
  }
});
